import React from "react";
import { UseFormRegister } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
type Inputs = any;

type text = { text: string };

interface Props {
  register: UseFormRegister<Inputs>;
  errors: any;
  name: string;
  options: text[];
  label: string;
  translateId?: string;
  disabled?: boolean;
  printEnabled?: boolean;
}

const Checkboxes: React.FC<Props> = ({
  register,
  errors,
  name,
  options,
  label,
  translateId,
  disabled,
  printEnabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <div className="relative my-5 grid md:grid-cols-2 grid-cols-1 w-full gap-[10px] md:gap-0">
      <div className="font-normal text-xl text-[#1E408E]">
        <Trans t={t}>{label}</Trans>
      </div>
      <div className="flex flex-row justify-between gap-x-4">
        <div className="grid gap-3 lg:px-5">
          {options.map((item, index) => (
            <label
              key={options.indexOf(item)}
              className="flex items-start gap-5"
              htmlFor={`${name}-${index}`}
            >
              <input
                type="radio"
                {...register(`${name}`)}
                id={`${name}-${index}`}
                value={`${item.text}`}
                disabled={disabled}
              />

              <span className="font-normal text-base leading-tight">
                <Trans t={t}>{item.text}</Trans>
              </span>
            </label>
          ))}
        </div>
        {printEnabled && (
          <div className="pr-10">
            <input type="checkbox" {...register(`print${name}`)} defaultChecked id={`${name}`} />
          </div>
        )}
      </div>
      <p className="text-red-500 text-xs">{errors[name]?.message}</p>
    </div>
  );
};

export default Checkboxes;
